/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";
import dayjs from "dayjs";
import { useMemo } from "react";
import DatePicker from "react-datepicker";

const dateTimeFormat = {
    "date": Config.dateFnDates.edit.date,
    "time": Config.dateFnDates.edit.time,
    "datetime": Config.dateFnDates.edit.datetime,
};
const parseFormats = {
    "date": Config.dates.internalFormats.date,
    "time": Config.dates.internalFormats.time,
    "datetime": Config.dates.internalFormats.datetime,
};

const DateTimeEdit = (props) => {
    const name = props?.name;
    const type = props?.type;
    const value = props?.value;
    const onChangeDateTime = props?.onChangeDateTime;

    const dateFormat = type ? dateTimeFormat[type] : dateTimeFormat["datetime"];
    const parseFormat = type ? parseFormats[type] : parseFormats["datetime"];
    const showTime = type === "datetime" || type === "time";
    const isTime = type === "time";

    const dateValue = useMemo(() => {
        if (value instanceof Date) {
            return value;
        }

        const date = dayjs(value, parseFormat);
        
        if (date.isValid()) {
            return date.toDate();
        }

        return null;
    }, [parseFormat, value]);

    return (
        <DatePicker
            className='simplicity-date-input'
            showTimeSelect={showTime}
            showTimeSelectOnly={isTime}
            id={`${name}_dateTime`}
            name={`${name}_dateTime`}
            selected={dateValue}
            dateFormat={dateFormat}
            onChange={onChangeDateTime}
            isClearable
            fullWidth={true}
        />
    );
};
export { DateTimeEdit };
